import Vue from 'vue'
import RentLazy from 'directives/rent-lazy'

Vue.directive('rent-lazy', RentLazy)
